<script>
import { ref } from "@vue/composition-api";
import { getStatusDetail, OrdersStatuses } from "@/core/constants/Orders.constants";
import { mapState } from "vuex";
import SiparislerService from "@/services/SiparislerService";

export default {
  name: "ChangeStatusModal",

  props: {
    value: {
      required: true,
      type: Boolean
    },
    orderId: {
      required: true,
      type: Number
    },
    status: {
      required: true,
      type: Number
    }
  },

  computed: {
    ...mapState({
      orderRelations: state => state.Siparisler.SiparisList.orderRelations,
      orderRelationsLoading: state => state.Siparisler.SiparisList.orderRelationsLoading
    }),
    currentRelationInfo() {
      return this.orderRelations[this.status];
    }
  },

  setup() {
    const updateStatusLoading = ref(false);
    const statusesList = Object.values(OrdersStatuses).map(o => getStatusDetail(o));

    return {
      orderStatuses: OrdersStatuses,
      updateStatusLoading,
      statusesList
    };
  },

  methods: {
    updateOrderStatus(orderStatus) {
      this.updateStatusLoading = true;
      SiparislerService.updateOrderStatus({ orderId: this.orderId, orderStatus }).then(({ status, message, data }) => {
        if (status === 200) {
          this.$snotify.success("Sipariş durumu değiştirildi", this.$t("PANEL.NOTIFY.SUCCESS"));
          this.$emit("update", data);
          this.$emit("input", false);
        } else {
          this.$snotify.error(message, this.$t("PANEL.NOTIFY.ERROR"));
        }
        this.updateStatusLoading = false;
      }).catch(() => {
        this.updateStatusLoading = false;
      });
    }
  },

  created() {
    this.$store.dispatch("Siparisler/SiparisList/getOrderRelations");
  }
};
</script>

<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400px">
    <v-card color="grey lighten-4" class="pb-1">
      <v-card-title class="align-center">
        <div class="text-body-1 font-weight-medium">
          Sipariş Durumunu Güncelle
        </div>
        <v-spacer />
        <div>
          <v-btn icon @click="$emit('input', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text v-if="orderRelationsLoading">
        <div class="d-flex flex-column align-center py-10">
          <v-progress-circular
            size="100"
            indeterminate
            color="primary"
            class="mb-2"
          ></v-progress-circular>
          <div class="text-body-1 font-weight-medium">
            Yükleniyor
          </div>
        </div>
      </v-card-text>
      <v-card-text v-else-if="currentRelationInfo" class="d-flex flex-column align-stretch pt-5 pb-2">
        <div
          :key="key"
          v-for="(statusDetail, key) in statusesList" class="mb-3"
          v-show="currentRelationInfo.includes(statusDetail.statusNumber)"
        >
          <v-btn
            rounded
            small
            style="width: 100%" class="text-capitalize"
            color="grey lighten-3"
            :loading="updateStatusLoading"
            @click="updateOrderStatus(statusDetail.statusNumber)"
          >
            <span class="d-flex justify-space-between align-center" style="width: 100%;">
              <span>
                <v-sheet :color="statusDetail.backgroundColor" width="35px" height="16px" rounded="xl"></v-sheet>
              </span>
              <span class="font-weight-bold" :style="{ color: statusDetail.backgroundColor }">
                {{ statusDetail.statusText }}
              </span>
              <span>
                <v-icon size="1.2rem">mdi-arrow-u-left-bottom</v-icon>
              </span>
            </span>
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn small color="red" dark @click="$emit('input', false)">
          <v-icon size="1.25rem" class="mr-1">mdi-close</v-icon>
          Kapat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>